module.exports = __webpack_public_path__ + "static/media/14UNEP22.5adf0ec8.jpg";